module.exports = __webpack_public_path__ + "static/img/icon_ylsp.7a9acb7e.png";